import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import { EditProjectContextProvider } from "../context/EditProjectContext";
import { useEditProject } from "./controller";
import CustomTabPanel from "../../../CustomTabPanel";
import ProjectHeader from "./ProjectHeader";
import { PROJECT_TABS, TAB_KEYS } from "./tabsConfig";
import DashboardTab from "./tabs/DashboardTab";
import BasicDataTab from "./tabs/BasicDataTab";
import AttorneyTab from "./tabs/AttorneyTab";
import TrackingTab from "./tabs/TrackingTab";
import DocumentsTab from "./tabs/DocumentsTab";
import FinancialTab from "./tabs/FinancialTab";

export default function EditProject({ 
  initialProjectNumber, 
  initialProjectId,
  onProjectNumberSearch,
  onProjectIdLoad,
  onClearProject
}) {
  const {
    loadProjectByNumber,
    loadProjectById,
    clearAllFields,
    updateProjectAddress,
    setDisableAllFields,
    initializeLoadingToast,
    updateLoadingToast,
    handleSendAttorney,
    disableAllFields,
    client,
    projectData,
    addressController,
    attorneyController,
    isAttorneySending,
    
    resetProjectNumber,
  } = useEditProject();

  const [activeTab, setActiveTab] = useState(TAB_KEYS.DASHBOARD);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Carregar projeto automaticamente quando initialProjectId for fornecido (deep linking)
  useEffect(() => {
    if (initialProjectId) {
      if (!projectData || projectData.id !== initialProjectId) {
        resetProjectNumber();
        clearAllFields();
        loadProjectById(initialProjectId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialProjectId]);

  // Carregar projeto automaticamente quando initialProjectNumber for fornecido
  useEffect(() => {
    if (initialProjectNumber && !initialProjectId) {
      if (!projectData || projectData.projectNumber !== initialProjectNumber) {
        resetProjectNumber();
        clearAllFields();
        loadProjectByNumber(initialProjectNumber);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialProjectNumber, initialProjectId]);

  const sharedProps = {
    projectData,
    isDisabled: disableAllFields,
    setDisabled: setDisableAllFields,
    initializeLoadingToast,
    updateLoadingToast,
  };

  return (
    <EditProjectContextProvider>
      <Box sx={{ mt: 2 }}>
        <ToastContainer />

        {projectData ? (
          <>
            <ProjectHeader projectData={projectData} onNavigateTab={setActiveTab} />

            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  "& .MuiTab-root": {
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "0.9rem",
                    minHeight: 48,
                  },
                }}
              >
                {PROJECT_TABS.map((tab, index) => (
                  <Tab
                    key={index}
                    label={tab.label}
                    icon={tab.icon}
                    iconPosition="start"
                  />
                ))}
              </Tabs>
            </Box>

            <CustomTabPanel value={activeTab} index={TAB_KEYS.DASHBOARD}>
              <DashboardTab {...sharedProps} />
            </CustomTabPanel>

            <CustomTabPanel value={activeTab} index={TAB_KEYS.BASIC_DATA}>
              <BasicDataTab
                {...sharedProps}
                clearAllFields={clearAllFields}
                client={client}
                addressController={addressController}
                attorneyController={attorneyController}
              />
            </CustomTabPanel>

            <CustomTabPanel value={activeTab} index={TAB_KEYS.ATTORNEY}>
              <AttorneyTab
                {...sharedProps}
                attorneyController={attorneyController}
                addressController={addressController}
                isAttorneySending={isAttorneySending}
                handleSendAttorney={handleSendAttorney}
                updateProjectAddress={updateProjectAddress}
              />
            </CustomTabPanel>

            <CustomTabPanel value={activeTab} index={TAB_KEYS.TRACKING}>
              <TrackingTab {...sharedProps} />
            </CustomTabPanel>

            <CustomTabPanel value={activeTab} index={TAB_KEYS.DOCUMENTS}>
              <DocumentsTab projectData={projectData} />
            </CustomTabPanel>

            <CustomTabPanel value={activeTab} index={TAB_KEYS.FINANCIAL}>
              <FinancialTab
                {...sharedProps}
                clearAllFields={clearAllFields}
              />
            </CustomTabPanel>
          </>
        ) : null}
      </Box>
    </EditProjectContextProvider>
  );
}
